import "../../Styles/Auth/ResetPassword.css";
import { useContext, useState } from "react";
import SectionOneLB1 from "../../Assets/SectionOneLB1.png";
import { ZGAContext } from "../../ZGAContext";
import { resetPassword } from "../../APIService";
import { useSearchParams } from "react-router-dom";


const ResetPassword = () => {
  const { showSuccessModal, setIsSubmitting } = useContext(ZGAContext);
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  console.log(token);
  // const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [resetPasswordInfo, setResetPasswordInfo] = useState({
    newPassword: "",
    confirmNewPassword: "",
  });
  const isDisabledFalse = resetPasswordInfo.newPassword === resetPasswordInfo.confirmNewPassword;

  function handleResetPasswordChange(e) {
    const name = e.target.name;
    const value = e.target.value;
    setResetPasswordInfo((prevResetPasswordInfo) => {
      return {
        ...prevResetPasswordInfo,
        [name]: value,
      };
    });
    console.log(resetPasswordInfo);
  }

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await resetPassword(token, resetPasswordInfo.newPassword);
      console.log(resetPassword);
      showSuccessModal("Reset password successful!", true, "/auth/login", "Login");
    } catch (error) {
      showSuccessModal(`${error.response?.data?.message || "An error occurred."}`, false, "", "");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="resetPassword">
      <div>
        <h1>Reset PASSWORD</h1>
        <form onSubmit={handleResetPassword}>
          <fieldset>
            <label>
              New Password
              <input
                type="password"
                name="newPassword"
                required
                pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                value={resetPasswordInfo.newPassword}
                onChange={handleResetPasswordChange}
              />
            </label>
            <label>
              Confirm New Password
              <input
                type="password"
                name="confirmNewPassword"
                required
                pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                value={resetPasswordInfo.confirmNewPassword}
                onChange={handleResetPasswordChange}
                // onChange={(e) => {
                //     setConfirmNewPassword(e.target.value);
                // }}
              />
            </label>
          </fieldset>
          <div>
            <input type="submit" name="submit" value="Reset Password" disabled={!isDisabledFalse} />
          </div>
        </form>
      </div>
      <div>
        <img src={SectionOneLB1} alt="Background" />
        <div className="gradient"></div>
      </div>
    </div>
  );
};

export default ResetPassword;
